import React from 'react';
import styles from './style.module.css';
import Text from 'components/shared/Text';
import { appStoreBadge, playStoreBadge, qrCodeCloseIcon } from 'assets/icons';
import { Box, Modal } from '@material-ui/core';
import { useContext } from 'react';
import MobileContext from 'context/MobileContext';
import { appStoreQRCode, playStoreQRCode } from 'assets/newIcons';
const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '10px',
  width: '305px',
  height: '362px',
};

const Footer = () => {
  const [openAppStoreQRCode, setOpenAppStoreQRCode] = React.useState(false);
  const handleOpenAppStoreQRCode = () => setOpenAppStoreQRCode(true);
  const handleCloseAppStoreQRCode = () => setOpenAppStoreQRCode(false);

  const [openPlayStoreQRCode, setOpenPlayStoreQRCode] = React.useState(false);
  const handleOpenPlayStoreQRCode = () => setOpenPlayStoreQRCode(true);
  const handleClosePlayStoreQRCode = () => setOpenPlayStoreQRCode(false);

  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : null;
  const lineBreak = isMobile ? <br /> : null;

  return (
    <>
      <div className={styles.container}>
        <Text className={`${styles.heading} ${mobClassName}`}>
          For the Full Digital Experience, {lineBreak} download the FITNESS SF App!
        </Text>
        <div className={`${styles.imgContainer} ${mobClassName}`}>
          <div className={styles.imgSubContainer1}>
            <img
              alt=""
              onClick={handleOpenAppStoreQRCode}
              className={styles.img}
              src={appStoreBadge}
            />
          </div>
          <div className={styles.imgSubContainer2}>
            <img
              alt=""
              onClick={handleOpenPlayStoreQRCode}
              className={styles.img}
              src={playStoreBadge}
            />
          </div>
        </div>
      </div>
      <Modal open={openAppStoreQRCode} onClose={handleCloseAppStoreQRCode}>
        <Box sx={boxStyle}>
          <div className={styles.closeIconContainer}>
            <img
              alt=""
              onClick={() => handleCloseAppStoreQRCode()}
              className={styles.closeIcon}
              src={qrCodeCloseIcon}
            />
          </div>
          <Text className={styles.imgHeading}>For iOS users</Text>
          <img
            alt=""
            style={{ marginTop: '5px' }}
            width={215}
            height={208}
            src={appStoreQRCode}
          />
        </Box>
      </Modal>

      <Modal open={openPlayStoreQRCode} onClose={handleClosePlayStoreQRCode}>
        <Box sx={boxStyle}>
          <div className={styles.closeIconContainer}>
            <img
              alt=""
              onClick={() => handleClosePlayStoreQRCode()}
              className={styles.closeIcon}
              src={qrCodeCloseIcon}
            />
          </div>
          <Text className={styles.imgHeading}>For Android users</Text>
          <img
            alt=""
            style={{ marginTop: '5px' }}
            width={215}
            height={208}
            src={playStoreQRCode}
          />
        </Box>
      </Modal>
    </>
  );
};

export default Footer;
